module.exports = __webpack_public_path__ + "img/activities-3.9d575083.jpg";